import LimitedAccess from "./limited-access";

export default LimitedAccess